<template>
    <div id="reportContainer" ref="reportContainer">
        <p class="text-capitalize font-weight-bold m-0 pt-0 mt-3">Lost Sales Report</p>
        <b-overlay :show="isBusy" rounded="sm" >
        <p class="text-capitalize">{{ reqData.msg }}</p>
            <div class="row" v-if="dataLostSalesReport">
                <div class="col-12">
                    <b-table-simple bordered hover small responsive>
                        <b-thead head-variant="none">
                            <b-tr>
                                <b-th rowspan="2">Date</b-th>
                                <b-th colspan="2">Rejected</b-th>
                                <b-th colspan="2">Cancelled</b-th>
                                <b-th colspan="2">Cancelled - Cust</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th>$ Sales</b-th>
                                <b-th># Items</b-th>
                                <b-th>$ Sales</b-th>
                                <b-th># Items</b-th>
                                <b-th>$ Sales</b-th>
                                <b-th># Items</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr v-for="(item) in dataLostSalesReport.rows" :key="item.date">
                                <b-td>{{moment(item.date).format("MM/DD/YY")}}</b-td>
                                <b-td>{{$c2d(item.rejectedSales) | currency}}</b-td>
                                <b-td>{{item.rejectedItems}}</b-td>                          
                                <b-td>{{$c2d(item.cancelledSales) | currency}}</b-td>
                                <b-td>{{item.cancelledItems}}</b-td>                                                          
                                <b-td>{{$c2d(item.customerCancelledSales) | currency}}</b-td>
                                <b-td>{{item.customerCancelledItems}}</b-td>                                                                                          
                            </b-tr>                      
                        </b-tbody>
                        <b-tfoot foot-variant="none">
                            <b-tr>
                                <b-td colspan="7"><br/></b-td>
                            </b-tr>
                            <b-tr v-bind="item = dataLostSalesReport.totals">
                                <b-th>Total</b-th>
                                <b-th>{{$c2d(item.rejectedSales) | currency}}</b-th>
                                <b-th>{{item.rejectedItems}}</b-th>                          
                                <b-th>{{$c2d(item.cancelledSales) | currency}}</b-th>
                                <b-th>{{item.cancelledItems}}</b-th>                                                          
                                <b-th>{{$c2d(item.customerCancelledSales) | currency}}</b-th>
                                <b-th>{{item.customerCancelledItems}}</b-th>                             
                            </b-tr>
                                <b-tr v-bind="item = dataLostSalesReport.averages">
                                <b-th>Average</b-th>
                                <b-th>{{$c2d(item.rejectedSales) | currency}}</b-th>
                                <b-th>{{item.rejectedItems}}</b-th>                          
                                <b-th>{{$c2d(item.cancelledSales) | currency}}</b-th>
                                <b-th>{{item.cancelledItems}}</b-th>                                                          
                                <b-th>{{$c2d(item.customerCancelledSales) | currency}}</b-th>
                                <b-th>{{item.customerCancelledItems}}</b-th>                           
                            </b-tr>
                        </b-tfoot>
                    </b-table-simple>
                </div>
            </div>
            <span class="text-danger">{{msgError}}</span>
        </b-overlay>                
    </div>
</template>
<script>
export default {
    props:{
        reqData : {type: Object}
    },
    data(){
        return { 
           msgError : "", 
           isBusy : false,
           dataLostSalesReport : null
        }
    },
    watch:{
        reqData : {
            deep: true,
            immediate: true,            
            handler() {
                this.lostSalesReport()
            }
		}
    },
    computed:{
    },
    methods:{        
        lostSalesReport() {
            this.msgError = ""
            this.dataLostSalesReport = null
            this.isBusy = true
            this.$store.dispatch('apiLostSalesReport', this.reqData)
                .then(_res => {
                    this.isBusy = false
                    if(_res.status){
                        this.dataLostSalesReport = _res.res
                    }
                }).catch((e)=>{
                    this.msgError = e.msgError;
                    this.isBusy = false
                })
        }
    },
    mounted(){
        this.lostSalesReport()
    }    
}
</script>